// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 939); hand-edits allowed (see docs/architecture.md)

/** `this.STIM_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_STIM_DEF(): any {
  return {
    "stimpack": {
      "id": 1,
      "tired": -9,
      "attack": 0,
      "protect": 0,
      "health": 30,
      "level": 1,
      "gold": 150,
      "diam": 1,
      "limit": 50,
      "name": "Стимпакет"
    },
    "jet": {
      "id": 2,
      "tired": -11,
      "attack": 10,
      "protect": -2,
      "health": 0,
      "level": 1,
      "gold": 300,
      "diam": 1,
      "limit": 50,
      "name": "Винт"
    },
    "buffout": {
      "id": 3,
      "tired": -11,
      "attack": -2,
      "protect": 10,
      "health": 0,
      "level": 1,
      "gold": 300,
      "diam": 1,
      "limit": 50,
      "name": "Стероиды"
    },
    "superstimpack": {
      "id": 4,
      "tired": -30,
      "attack": 0,
      "protect": 0,
      "health": 100,
      "level": 1,
      "gold": 3000,
      "diam": 3,
      "limit": 50,
      "name": "Суперстимпакет"
    },
    "psycho": {
      "id": 5,
      "tired": -100,
      "attack": 25,
      "protect": 25,
      "health": 150,
      "level": 1,
      "gold": 8000,
      "diam": 8,
      "limit": 50,
      "name": "Психо"
    },
    "fruit": {
      "id": 6,
      "tired": -1000,
      "attack": 50,
      "protect": 50,
      "health": 400,
      "level": 1,
      "gold": 35000,
      "diam": 35,
      "limit": 50,
      "name": "Мутафрукт"
    }
  };
}
